module.exports = __webpack_public_path__ + "static/media/BlockCard.06b6bb8a.svg";